import React from "react";
import Search from "./components/search";
import Content from "./components/content";

const Indicator = () => {

  return (
    <>
      <Search />
      <Content />
    </>
  );
};

export default Indicator;
